import { render, staticRenderFns } from "./equipmentManualFolder.vue?vue&type=template&id=56887980&scoped=true"
import script from "./equipmentManualFolder.vue?vue&type=script&lang=js"
export * from "./equipmentManualFolder.vue?vue&type=script&lang=js"
import style0 from "./equipmentManualFolder.vue?vue&type=style&index=0&id=56887980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56887980",
  null
  
)

export default component.exports